export const skills = [
    // Languages
    { name: "C#", icon: "mdi:language-csharp" },
    { name: "Rust", icon: "mdi:language-rust" },
    { name: "TypeScript", icon: "mdi:language-typescript" },
    { name: "JavaScript", icon: "mdi:language-javascript" },
    // Frontend
    { name: "React", icon: "mdi:react" },
    { name: "Flutter", icon: "simple-icons:flutter" },
    { name: "Tailwind", icon: "mdi:tailwind" },
    { name: "CSS", icon: "mdi:language-css3" },
    // Data / tooling / infra / AI
    { name: "MySql", icon: "mdi:database" },
    { name: "Git", icon: "mdi:git" },
    { name: "AWS", icon: "mdi:aws" },
    { name: "Anthropic", icon: "simple-icons:claude" },
];